import React from "react";

const ExamPatternMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      {/* Exam Structure */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">Structure of the Examination</h3>
        <p>The UPSC CSE is conducted in three phases:</p>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <strong>Preliminary Examination:</strong> An objective-type test
            that serves as a screening stage.
          </li>
          <li className="list-group-item">
            <strong>Main Examination:</strong> A written exam evaluating a
            candidate’s analytical and intellectual capabilities.
          </li>
          <li className="list-group-item">
            <strong>Personality Test (Interview):</strong> A final assessment of
            a candidate’s suitability for civil services.
          </li>
        </ul>
      </div>

      {/* Preliminary Exam */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">Preliminary Examination</h3>
        <p>
          The Prelims consists of two papers with multiple-choice questions.
          This examination acts as a qualifying exam, and its marks do not
          contribute to the final ranking.
        </p>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Paper</th>
              <th>Subject</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Paper I</td>
              <td>General Studies</td>
              <td>200</td>
            </tr>
            <tr>
              <td>Paper II</td>
              <td>CSAT (Aptitude Test) - Qualifying (33%)</td>
              <td>200</td>
            </tr>
          </tbody>
        </table>
        <p>
          <strong>Total Marks:</strong> 400
        </p>
        <p>
          <strong>Duration:</strong> 2 hours per paper
        </p>
        <p>
          <strong>Negative Marking:</strong> One-third (0.33) of the marks
          assigned to a question will be deducted for incorrect answers.
        </p>
        <p>
          <strong>Language:</strong> Both papers are available in English and
          Hindi.
        </p>
        <p>
          <strong>Candidates qualifying Prelims:</strong> About 12-13 times the
          total vacancies proceed to Mains.
        </p>
      </div>

      {/* Mains Exam */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">Main Examination</h3>
        <p>
          The Mains exam consists of nine papers, out of which seven are counted
          for ranking, while two are qualifying in nature.
        </p>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Paper</th>
              <th>Subject</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Paper A</td>
              <td>Indian Language (Qualifying)</td>
              <td>300</td>
            </tr>
            <tr>
              <td>Paper B</td>
              <td>English (Qualifying)</td>
              <td>300</td>
            </tr>
            <tr>
              <td>Paper I</td>
              <td>Essay</td>
              <td>250</td>
            </tr>
            <tr>
              <td>Paper II</td>
              <td>General Studies - I</td>
              <td>250</td>
            </tr>
            <tr>
              <td>Paper III</td>
              <td>General Studies - II</td>
              <td>250</td>
            </tr>
            <tr>
              <td>Paper IV</td>
              <td>General Studies - III</td>
              <td>250</td>
            </tr>
            <tr>
              <td>Paper V</td>
              <td>General Studies - IV</td>
              <td>250</td>
            </tr>
            <tr>
              <td>Paper VI</td>
              <td>Optional Subject - Paper 1</td>
              <td>250</td>
            </tr>
            <tr>
              <td>Paper VII</td>
              <td>Optional Subject - Paper 2</td>
              <td>250</td>
            </tr>
          </tbody>
        </table>
        <p>
          <strong>Exemptions:</strong> Candidates from Arunachal Pradesh,
          Manipur, Meghalaya, Mizoram, Nagaland, and Sikkim are exempt from
          Paper A.
        </p>
        <p>
          <strong>Exemptions for PwBD:</strong> Hearing Impairment candidates
          with proper documentation are exempt from Paper A.
        </p>
        <p>
          <strong>Qualification Requirement:</strong> Both Paper A and Paper B
          are of Matriculation (10th standard) level. Candidates must secure at
          least 25% in each for their remaining papers to be evaluated.
        </p>
        <p>
          <strong>Duration:</strong> 3 hours per paper
        </p>
        <p>
          <strong>Total Marks (Written):</strong> 1750
        </p>
      </div>

      {/* Interview */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">Personality Test (Interview)</h3>
        <p>
          Candidates who qualify the written exam are called for an interview.
          The Interview/Personality Test is conducted to assess the candidate’s
          personality, decision-making ability, leadership skills, and knowledge
          of current affairs.
        </p>
        <p>
          <strong>Interview Marks:</strong> 275 (No minimum qualifying marks)
        </p>
        <p>
          <strong>Final Ranking:</strong> The total marks of the Mains (1750)
          and the Interview (275) are combined, making a grand total of 2025
          marks.
        </p>
      </div>
    </div>
  );
};

export default ExamPatternMain;
